// @ts-nocheck
import { yupResolver } from "@hookform/resolvers/yup";
import { useCreateHub } from "hooks/hub-management/useHub";
import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import BasicFormSection from "../form/BasicForm.section";
import { validateSchema, validateSchemaBasicForm } from "../form/validate";
import { mapArrayOptionToArrayValue, convertTimeToMinutes } from "../utils";
import useHubForm from "../form/useHubForm";

const CreateForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["hub"]);

  const mainForm = useForm({
    resolver: yupResolver(validateSchemaBasicForm(t)),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {},
  });

  const { getValues, handleSubmit } = mainForm;
  const { is_level_2 } = useHubForm({ mainForm });

  const onSuccessCreateHub = data => {
    navigate(`/hub/${data.data.id}`);
  };

  const onErrorCreateHub = () => {};

  const { mutate: createHub } = useCreateHub(
    onSuccessCreateHub,
    onErrorCreateHub
  );

  const onSubmit = data => {
    const fixed_days_off = mapArrayOptionToArrayValue(data.fixed_days_off);

    createHub({
      name: data.hub_name,
      hub_order_code: data.hub_order_code,
      hub_transport_order_code: data.hub_transport_code,
      is_center: data.is_center ? 1 : 0,
      address: data.address,

      ...(data.ward_code?.value && { ward_code: data.ward_code.value }),
      ...(data.district_code?.value && {
        district_code: data.district_code.value,
      }),
      ...(data.province_code?.value && {
        province_code: data.province_code.value,
      }),

      ...(data.province_code_new?.value && {
        province_code_new: data.province_code_new.value,
      }),
      ...(data.district_code_new?.value && {
        district_code_new: data.district_code_new.value,
      }),

      parent_hub_id: data.parent_hub_id?.value,
      fixed_days_off: fixed_days_off.length > 0 ? fixed_days_off : undefined,
      forwarding_current_shift: data.forwarding_current_shift ? 1 : 0,
      allowed_time: data.allowed_time
        ? convertTimeToMinutes(data.allowed_time)
        : undefined,
      blood_collection_limit_time: data.blood_collection_limit_time
        ? convertTimeToMinutes(data.blood_collection_limit_time)
        : undefined,
    });
  };
  return (
    <Fragment>
      <Row className="mb-5">
        <Col>
          <form onSubmit={handleSubmit(onSubmit)}>
            <BasicFormSection mainForm={mainForm} />
            <Row xs={2}>
              <Col className="text-start">
                <Link
                  to={"/hub/list"}
                  size="xs"
                  className="btn btn-danger btn-label"
                >
                  <i className="fas fa-ban label-icon"></i>
                  {t("button.cancel")}
                </Link>
              </Col>
              <Col className="text-end">
                <Button
                  type="submit"
                  size="xs"
                  style={{ backgroundColor: "#3C64B1" }}
                  className="btn btn-primary btn-label"
                >
                  <i className="fas fa-save label-icon"></i>
                  {t("button.submit")}
                </Button>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>
    </Fragment>
  );
};

export default CreateForm;
